/**
 *
 * Created Date: 2019-08-23, 11:36:22 (zhenliang.sun)
 * Last Modified: 2019-08-23, 13:14:24 (zhenliang.sun)
 * Email: zhenliang.sun@gmail.com
 *
 * Distributed under the MIT license. See LICENSE file for details.
 * Copyright (c) 2019 vhall
 */
import log from 'loglevel';

/**
 * 延迟执行消费队列
 * 说明，正常塞数据进去，然后间隔n毫秒后，一个一个出队列，按照队列设置的回调进行处理.
 * 使用场景，H5文档中，快速点击下一步，下一页等操作会有大量信息产生。而使用http进行接口请求
 * 由于HTTP 请求到达不可预知可能存在先收到后面的数据，后收到前面的数据。导致信息错乱
 * 在这里人为的进行消息延迟发送，减少出错的概率
 *
 * @export
 * @class DeferQueue
 * @author zhenliang.sun
 */
export default class DeferQueue {
  constructor(delay = 350) {
    this.running = false;
    this.delayTime = delay;
    this.queue = [];
  }

  push(data, callBK) {
    this.queue.push({ data, fn: callBK });
    this._checkNext();
  }

  async _startExecuteQueue() {
    this.running = true;
    const item = this.queue.shift();
    if (!item) {
      log.error('延迟队列数据有问题，为空');
      return;
    }
    const { fn, data } = item;
    fn(data);

    await this._delay(this.delayTime);
    this.running = false;
    this._checkNext();
  }

  _delay(time) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve();
      }, time);
    });
  }

  _checkNext() {
    if (this.queue.length > 0) {
      if (this.running) {
        return;
      }
      this._startExecuteQueue();
    } else {
      this.running = false;
    }
  }
}
